<template>
    <div class="web">
        <Header :type="'planes'"></Header>
        <main class="py-5 planes">
        <div class="container mb-5">
            <div class="row mb-4">
                <h1 class="text-grey text-center"><span class="bg-orange">Membresías</span> para Consultores</h1>
            </div>

            <div class="row">
                <div class="col-4 d-inline-block">
                    <div class="card card-orange h-100">
                        <div class="card-body">
                            <div class="text-center text-blue">
                                <img :src="urlWeb + '/assets/images/logos/credit-card.png'" style="width: 25%;">
                                <h3>MENSUAL</h3>
                            </div>
                            <ul class="">
                                <li class="mb-2">Tarifa mensual única.</li>
                                <li class="mb-2">Podrás enviar ofertas a las oportunidades que ajuste con tu primera
                                    especialización.</li>
                                <li class="mb-2">Renovación automática. (Cancela cuando quieras)</li>
                                <li class="mb-2">Recibe notificaciones de nuevos proyectos.</li>
                            </ul>
                        </div>
                        <div class="card-footer text-blue bg-orange text-center mb-0">
                            <strong>$ 9.50 USD</strong>
                        </div>
                    </div>
                </div>
                <div class="col-4 d-inline-block">
                    <div class="card card-orange h-100">
                        <div class="card-body">
                            <div class="text-center text-blue">
                                <img :src="urlWeb + '/assets/images/logos/money.png'" style="width: 25%;">
                                <h3>SEMESTRAL</h3>
                            </div>
                            <ul class="">
                                <li class="mb-2">Obten 3% de descuento sobre la tarifa mensual.</li>
                                <li class="mb-2">Podras enviar ofertas a las oportunidades que ajusten con tu primera y
                                    segunda especialización.</li>
                                <li class="mb-2">Duplica la posibilidad de éxito.</li>
                                <li class="mb-2">Renovación automática. <span class="text-grey">(Cancela cuando
                                        quieras)</span></li>
                                <li class="mb-2">Recibe notificaciones de nuevos proyectos.</li>
                            </ul>
                        </div>
                        <div class="card-footer text-blue bg-orange text-center mb-0">
                            <strong>$ 55.29 USD</strong>
                        </div>
                    </div>
                </div>
                <div class="col-4 d-inline-block">
                    <div class="card card-orange h-100">
                        <div class="card-body">
                            <div class="text-center text-blue">
                                <img :src="urlWeb + '/assets/images/logos/tablet.png'" style="width: 25%;">
                                <h3>ANUAL</h3>
                            </div>
                            <ul class="">
                                <li class="mb-2">Obten 5% de descuento sobre la tarifa mensual.</li>
                                <li class="mb-2">Podras enviar ofertas a las oportunidades que ajusten con tus tres
                                    especializaciones.</li>
                                <li class="mb-2">Triplica las posibilidades de éxito.</li>
                                <li class="mb-2">Renovación automática. <span class="text-grey">(Cancela cuando
                                        quieras)</span></li>
                                <li class="mb-2">Recibe notificaciones de nuevos proyectos.</li>
                            </ul>
                        </div>
                        <div class="card-footer text-blue bg-orange text-center mb-0">
                            <strong>$ 108.30 USD</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <div class="row mb-4">
                <div class="col text-center">
                    <router-link to="/Registro" class="btn btn-subscribe-lg">Suscríbete</router-link>
                </div>
            </div>
        </div>

        <div class="container mb-5">
            <hr style="max-height: 3px; width: 40%; margin: 0 auto;">
        </div>

        <div class="container mb-5">
            <div class="row mb-4">
                <h1 class="text-grey text-end">Costo para <span class="bg-blue">Empresas</span></h1>
            </div>

            <div class="row">
                <p>Nos complace informarte que el registro en nuestra plataforma, publicar proyectos y conversar con los
                    consultores es totalmente gratuito. Queremos brindart la oportunidad de unirte a nuestra comunidad sin
                    ningún costo. No hay barreras económicas para comenzar a explorar las diversas oportunidades y servicios
                    que ofrecemos.</p>

                <p>Nuestro modelo de negocio se basa en un cobro de una tarifa del 9% sobre el monto del proyecto adjudicado. Si posteriormente pagas al
                    Consultor más que el monto de la oferta original, también cargaremos la tarifa de proyecto por cada pago
                    excedente.</p>

                <p>Esto significa que no te preocuparás por gastos adicionales ni tarifas ocultas al utilizar nuestros
                    servicios, nos enorgullece ofrecerte una transparencia total y una relación justa en términos de costos,
                    lo que te permitirá optimizar el presupuesto de TI de tu empresa.</p>

                <p>En tiempos donde cada centavo cuenta, nos comprometemos a brindarte beneficios financieros
                    significativos al alcanzar el éxito en tus proyectos con nosotros.</p>

                <p>¡Regístrate hoy mismo y descubre cómo podemos ayudarte a maximizar tu rendimiento y lograr tus objetivos
                    de manera rentable!</p>
            </div>
        </div>

        <div class="container mb-5">
            <hr style="max-height: 3px; width: 40%; ">
        </div>

        <div class="container mb-5">
            <div class="row mb-4">
                <div class="col text-end">
                    <router-link to="/Registro" class="btn btn-subscribe-lg">Suscríbete</router-link>
                </div>
            </div>
        </div>

    </main>
        
    </div>
  </template>
    
    <script>
    import { mapState } from 'vuex'
    import Header from '@/components/Header'
    export default {
      computed:{
        ...mapState(['urlWeb'])
    },
      name: 'Planes',
      components:{
        Header
    },
      data () {
        return {
        }
      }
    }
    </script>


// WEBPACK FOOTER //
// src/views/Home/Planes.vue